const citationsCodeMap = {
  // GRI - General Disclosures - Organization Profile
  '102-1': 'gri-gd-organization-profile',
  '102-2': 'gri-gd-organization-profile',
  '102-3': 'gri-gd-organization-profile',
  '102-4': 'gri-gd-organization-profile',
  '102-5': 'gri-gd-organization-profile',
  '102-6': 'gri-gd-organization-profile',
  '102-7': 'gri-gd-organization-profile',
  '102-9': 'gri-gd-organization-profile',
  '102-12': 'gri-gd-organization-profile',
  // GRI - General Disclosures - Strategy
  '102-14': 'gri-gd-strategy',
  '102-15': 'gri-gd-strategy',
  // GRI - General Disclosures - Ethics & Integrity
  '102-16': 'gri-gd-ethics-integrity',
  '102-17': 'gri-gd-ethics-integrity',
  // GRI - General Disclosures - Governance
  '102-18': 'gri-gd-governance',
  '102-20': 'gri-gd-governance',
  '102-21': 'gri-gd-governance',
  '102-22': 'gri-gd-governance',
  '102-23': 'gri-gd-governance',
  '102-24': 'gri-gd-governance',
  '102-25': 'gri-gd-governance',
  '102-26': 'gri-gd-governance',
  '102-28': 'gri-gd-governance',
  '102-29': 'gri-gd-governance',
  '102-30': 'gri-gd-governance',
  '102-32': 'gri-gd-governance',
  '102-33': 'gri-gd-governance',
  '102-35': 'gri-gd-governance',
  '102-36': 'gri-gd-governance',
  '102-37': 'gri-gd-governance',
  '102-38': 'gri-gd-governance',
  '102-38': 'gri-gd-governance',
  '102-43': 'gri-gd-governance',
  '102-45': 'gri-gd-governance',
  '102-47': 'gri-gd-governance',
  // GRI - General Disclosure - Reporting Practice
  '102-50': 'gri-gd-reporting-practice',
  '102-51': 'gri-gd-reporting-practice',
  '102-52': 'gri-gd-reporting-practice',
  '102-53': 'gri-gd-reporting-practice',
  '102-55': 'gri-gd-reporting-practice',
  // GRI - Economic Performance
  '201-1': 'gri-gd-economic-performance',
  '201-2': 'gri-gd-economic-performance',
  '201-3': 'gri-gd-economic-performance',
  // GRI - Indirect Economic Impacts
  '203-1': 'gri-indirect-economic-impacts',
  '203-2': 'gri-indirect-economic-impacts',
  // GRI - Anti-Corruption
  '205-1': 'gri-anti-corruption',
  '205-2': 'gri-anti-corruption',
  // GRI - Anti-competitive Behavior
  '206-1': 'gri-anti-competitive-behavior',
  // GRI - Energy
  '302-1': 'gri-energy',
  '302-3': 'gri-energy',
  '302-4': 'gri-energy',
  // GRI - Water and Effluents
  '303-1': 'gri-water-effluents',
  '303-5': 'gri-water-effluents',
  // GRI - Emissions
  '305-1': 'gri-emissions',
  '305-2': 'gri-emissions',
  '305-4': 'gri-emissions',
  '305-5': 'gri-emissions',
  // GRI - Effluents and Waste
  '306-3': 'gri-effluents-waste',
  '306-4': 'gri-effluents-waste',
  // GRI - Employment
  '401-1': 'gri-employment',
  '401-2': 'gri-employment',
  '401-3': 'gri-employment',
  // GRI - Occupational Health & Safety
  '403-1': 'gri-occuptational-health-safety',
  '403-2': 'gri-occuptational-health-safety',
  '403-9': 'gri-occuptational-health-safety',
  // GRI - Training & Education
  '404-2': 'gri-training-education',
  '404-3': 'gri-training-education',
  // GRI - Diversity & Equal Opportunity
  '405-1': 'gri-diversity-equal-opportunity',
  // GRI - Freedom of Association
  '407-1': 'gri-freedom-association',
  // GRI - Public Policy
  '415-1': 'gri-public-policy',
  // GRI - Marketing and Labeling
  '417-1': 'gri-marketing-labeling',
  // GRI - Public Policy
  '419-1	': 'gri-public-policy',
  // SASB
  'HC-MS-250a.1': 'sasb',
  'HC-MS-250a.4': 'sasb',
  'HC-MS-270a.1': 'sasb',
  'HC-MS-270a.2': 'sasb',
  'HC-MS-430a.3': 'sasb',
  'HC-MS-510a.2': 'sasb',
  // TCFD
  'Governance': 'tcfd',
  'Strategy': 'tcfd',
  'Risk Management': 'tcfd',
  'Metrics and Targets': 'tcfd',
}

export default citationsCodeMap